import React from "react";
import { FaCamera } from "react-icons/fa";
import "../../css/TripDetailsPhoto.css";

const PhotoDetails = ({ photoUrl, altText = "Trip Photo", placeholderIcon = <FaCamera size={100} color="#ccc" /> }) => {
  const finalPhotoUrl = photoUrl
    ? `${photoUrl}${photoUrl.includes("?") ? "&" : "?"}t=${Date.now()}`
    : null;

  return (
    <div className="photoContainer">
      {finalPhotoUrl ? (
        <img
          src={finalPhotoUrl}
          alt={altText}
        />
      ) : (
        <div className="photoPlaceholder">
          {placeholderIcon}
        </div>
      )}
    </div>
  );
};
export default PhotoDetails;
